// extracted by mini-css-extract-plugin
module.exports = {"sitewideAlertBanner":"az_Lhc","sitewideAlertBannerIconWrapper":"az_Mhc","sitewideAlertBannerIcon":"az_Nhc","sitewideAlertBannerText":"az_Ohc"};